import React, {useCallback} from "react"

import FieldSelectEntityField from "../../select-entity-field"
import FieldProto from "../../../../../proto/field-proto"
import FieldSelectEntityField_SingleEntityPopover from "./single-entity"
import FieldSelectEntityField_MultipleEntitiesPopover from "./multiple-entities"

// const debug = "FieldSelectEntityField_Popover"
const debug = false

export default function FieldSelectEntityField_Popover(props:any) {

    const field : FieldSelectEntityField = props.field

    const value: any = props.field.getViewValue(props.model)
    const selectedFieldIds = props.field.fieldParams.selectedFieldIds ? props.field.fieldParams.selectedFieldIds : [value]

    debug && console.log(debug, 'render', selectedFieldIds, value, field)

    const onClickOutside = useCallback((e:React.SyntheticEvent) => {
        if(gd.utils.Dom.findNodeByClassName(e.target, "gd-popover-add-column-new")) return;

        props.parent.hidePopover()
    }, [])

    const onSelect = (fieldId:ID | null, params?: any, selectedField?: FieldProto) => {
        props.parent.hidePopover()

        debug && console.log(debug, 'onSelect', fieldId, params, selectedField)

        props.parent.onValueChange(selectedField)
    }

    if (field.fieldsCollections.length === 1) {
        return <FieldSelectEntityField_SingleEntityPopover field            = {props.field}
                                                           model            = {props.model}
                                                           parent           = {props.parent}
                                                           offset           = {props.offset}
                                                           options          = {props.options}
                                                           onClickOutside   = {onClickOutside}
                                                           onSelect         = {onSelect}/>
    } else {
        return <FieldSelectEntityField_MultipleEntitiesPopover field            = {props.field}
                                                               model            = {props.model}
                                                               parent           = {props.parent}
                                                               offset           = {props.offset}
                                                               options          = {props.options}
                                                               onClickOutside   = {onClickOutside}
                                                               onSelect         = {onSelect}/>
    }
}
